// extracted by mini-css-extract-plugin
export default {"main":"LeftSider_main__+T925","top_menu":"LeftSider_top_menu__pI-28","bottom_menu":"LeftSider_bottom_menu__NYdy8"};